export const mutation_postAzienda = `
mutation postAzienda($tenantId: String!, $dataInput: InputDataAzienda!) {
    postAzienda(tenantId: $tenantId, dataInput: $dataInput) {
        id
        tenantId
        denominazione
        cf
        pIva
        addrPaeseId
        addrProvinciaId
        addrProvincia
        addrComuneId
        addrComune
        addrIndirizzo
        addrN
        addrCap
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        meteringSlotId
    }
}`;
export const mutation_updateAzienda = `
mutation updateAzienda($id: Int!, $tenantId: String!, $dataInput: InputDataAzienda!) {
    updateAzienda(id: $id, tenantId: $tenantId, dataInput: $dataInput) {
        id
        tenantId
        denominazione
        cf
        pIva         
        addrPaeseId
        addrProvinciaId
        addrProvincia
        addrComuneId
        addrComune
        addrIndirizzo
        addrN
        addrCap
        createdOn
        modifiedOn
        createdBy
        modifiedBy
        meteringSlotId
    }
}`;
export const mutation_deleteAzienda = `
mutation deleteAzienda($id: Int!, $tenantId: String!) {
    deleteAzienda(id: $id, tenantId: $tenantId) {
        id        
        message
    }
}`;

//#region old
export const mutation_add_azienda = `
mutation insertAzienda($tenantId: String!, $denominazione: String!, $cf: String!, $pIva: String!, $addrPaeseId: Int, $addrProvinciaId: Int, $addrProvincia: String, $addrComuneId: Int, $addrComune: String, $addrIndirizzo: String, $addrN: String, $addrCap: String, $meteringSlotId: Int) {
    insert_azienda_one(object: {TenantId: $tenantId, Denominazione: $denominazione, Cf: $cf, PIva: $pIva, AddrPaeseId: $addrPaeseId, AddrProvinciaId: $addrProvinciaId, AddrProvincia: $addrProvincia, AddrComuneId: $addrComuneId, AddrComune: $addrComune, AddrIndirizzo: $addrIndirizzo, AddrN: $addrN, AddrCap: $addrCap, MeteringSlotId: $meteringSlotId}) {
        Id
        Denominazione
        Cf
        PIva
        AddrPaeseId
        AddrProvinciaId
        AddrProvincia
        AddrComuneId
        AddrComune
        AddrIndirizzo
        AddrN
        AddrCap
        CreatedOn
        ModifiedOn
        CreatedBy
        ModifiedBy
        MeteringSlotId
    }
}`;
export const mutation_update_azienda = `
mutation updateAzienda($id: Int!, $denominazione: String!, $cf: String!, $pIva: String!, $addrPaeseId: Int!, $addrProvinciaId: Int!, $addrProvincia: String!, $addrComuneId: Int!, $addrComune: String!, $addrIndirizzo: String!, $addrN: String!, $addrCap: String!, $meteringSlotId: Int) {
    update_azienda(where: {Id: {_eq: $id}}, _set: {Denominazione: $denominazione, Cf: $cf, PIva: $pIva, AddrPaeseId: $addrPaeseId, AddrProvinciaId: $addrProvinciaId, AddrProvincia: $addrProvincia, AddrComuneId: $addrComuneId, AddrComune: $addrComune, AddrIndirizzo: $addrIndirizzo, AddrN: $addrN, AddrCap: $addrCap, ModifiedOn: "now()", MeteringSlotId: $meteringSlotId}) {
        returning {
            Id
            TenantId
            Denominazione
            Cf
            PIva
            AddrPaeseId
            AddrProvinciaId
            AddrProvincia
            AddrComuneId
            AddrComune
            AddrIndirizzo
            AddrN
            AddrCap
            CreatedOn
            ModifiedOn
            CreatedBy
            ModifiedBy
            MeteringSlotId
        }
    }
}`;
export const mutation_delete_azienda = `
mutation deleteAzienda($tenantId: String!, $id: Int!) {
    delete_azienda(where: {Id: {_eq: $id}, TenantId: {_eq: $tenantId}}) {
        affected_rows
    }
}`;
//#endregion